// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__lKRPO","name":"ConsentHeader_name__11sTe","birthday":"ConsentHeader_birthday__3P4cV","skeleton":"ConsentHeader_skeleton__2-dh1"};